export function getCookie(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function setCookie(key,data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function removeCookie(key) {
  return localStorage.removeItem(key);
}
export function clearCookie() {
  return localStorage.clear();
}
